<template>
  <i-select
    v-model="currentValue"
    multiple
    filterable
    :disabled="disabled"
    :loading="loading"
    @on-change="updateValue"
  >
    <i-option
      v-for="country in options"
      :value="country.iso3"
      :key="country.iso3"
      :label="country.idmc_short_name"
    ></i-option>
  </i-select>
</template>

<script>
import axios from "axios";

export default {
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      currentValue: this.value || [],
      options: [],
      loading: false,
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue || [];
    },
  },
  created() {
    axios
      .get("/psql/geo_entities", {
        params: { select: "idmc_short_name,iso3" },
      })
      .then(response => {
        this.options = response.data;
        this.loading = false;
      })
      .catch(error => {
        console.error(error);
        this.loading = false;
      });
  },
  methods: {
    updateValue(newValue) {
      this.currentValue = newValue;
      this.$emit("input", newValue);
      this.$emit("on-change", newValue);
    },
  },
};
</script>

<style lang="css"></style>
